<h1>{{'cs.psv.person.profile.edit.header' | hisUi}}</h1>
<div class="clearAndSpace"></div>
<his-dialog-header
	(save)="savePersonProfile()"
	[showBackButton]="true"
	[showResetButton]="false"> 
	
    <ng-container dataBox>
        <strong>{{'cs.psv.person.profile.edit' | hisUi:person?.firstname: person?.surname}}</strong>
    </ng-container>

    <ng-container customResultButtons>
        <button (click)="navigationService.navigateToLastBackUrl()"><span>{{'common.back' | hisUi}}</span></button>
    </ng-container>


	<ng-container elementsRight *ngIf="personProfileDataExist">
        <his-translation-selector [defaultLanguage]="defaultLanguage"></his-translation-selector>
    </ng-container>
</his-dialog-header>

<div class="clearAndSpace"></div>

<!-- Tabs -->
<div>
    <p-tabView id="tabView" class="columnThreeQuarter">
	    <p-tabPanel lazy="true" [header]="'cs.psv.person.profile.basicData.header'|hisUi" *ngIf="isMainDataVisible()">
            <his-info-panel [i18nKey]="'cs.psv.person.profile.basicData.header'" [target]="'person.profile'"></his-info-panel>
            <psv-personprofile-edit-basic-data *ngIf="personProfile"
                [defaultLanguage]="defaultLanguage"
                [personProfile]="personProfile"
            ></psv-personprofile-edit-basic-data>
	    </p-tabPanel>
	    <p-tabPanel lazy="true" [header]="'cs.psv.person.profile.classification.header'|hisUi" *ngIf="isClassificationsPanelVisible()">
            <his-info-panel [i18nKey]="'cs.psv.common.classification'" [target]="'person.profile'"></his-info-panel>
            
            <psv-personprofile-edit-classifications *ngIf="personProfile && !personProfile.employmentClassificationsDataSource"
                [classifications]="personProfile.personClassifications"
                [header]="'fs.res.common.classifications' | hisUi"
                [researchAreaDdKey]="'cs.psv.person.profile.classification.researchArea'"
                [researchAreaKdsfDdKey]="'cs.psv.person.profile.classification.researchAreaKdsf'"
                [subjectAreaDdKey]="'cs.psv.person.profile.classification.subjectArea'">
            </psv-personprofile-edit-classifications> 
            <psv-personprofile-edit-employment-classifications *ngIf="personProfile && personProfile.employmentClassificationsDataSource"
                [employmentClassifications]="personProfile.employmentClassifications">
            </psv-personprofile-edit-employment-classifications>
	    </p-tabPanel>
    </p-tabView>
</div>
